import { render } from "./DashboardWishList.vue?vue&type=template&id=4b8e8c20"
import script from "./DashboardWishList.vue?vue&type=script&lang=js"
export * from "./DashboardWishList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/poshakjojomama-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__